// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0c5720f8","453":"26c70878"}[chunkId] + ".chunk.js";
};